import React from 'react';

export default function KulkarniConsultingNote({ className = '' }) {
  return (
    <footer className={`w-full border-t border-emerald-200/60 bg-gradient-to-r from-white/95 via-emerald-50/40 to-amber-50/30 ${className}`}>
      <div className="max-w-5xl mx-auto px-3 sm:px-5 py-4 sm:py-5 flex items-center justify-center gap-3 text-sm sm:text-base text-slate-600 text-center font-medium leading-snug">
        <img
          src="/icons/kc-logo-round-nobg.png"
          alt="Kulkarni Consulting"
          className="h-12 w-12 sm:h-14 sm:w-14 shrink-0"
        />
        <span>
          Tato webová aplikace byla vyvinuta a je spravována společností{' '}
          <a
            href="https://www.kulkarni.cz"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-brand-emerald underline decoration-brand-gold/60 underline-offset-2 hover:text-brand-gold"
          >
            Kulkarni Consulting
          </a>
          .
        </span>
      </div>
    </footer>
  );
}
